import { createSafeContext } from '@libs/ui/ds/lib/internals'

export type MenuContext = {}

export const [MenuProvider, useMenuContext] = createSafeContext<MenuContext>({
  context: 'Menu'
})
